import "../../_namespaces.js";
import "../../_generated_templates.js";
import "./response.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseFreeText = class ResponseFreeText extends AssessmentViewer.Views.Response {
  constructor() {
    super(...arguments);
    this.updateSelectedState = this.updateSelectedState.bind(this);
    this.findInput = this.findInput.bind(this);
  }

  // EVENT HANDLERS

  handleTextChange() {
    return this.updateSelectedState();
  }

  // HELPER METHODS

  updateSelectedState() {
    return this.model.set("selected", !!jQuery.trim(this.findInput().val()));
  }

  findInput() {
    return this.$el.find("[name=text]");
  }
};
AssessmentViewer.Views.ResponseFreeText.prototype.template = _.template(AssessmentViewer.Templates.Response.free_text);

AssessmentViewer.Views.ResponseFreeText.prototype.events = {
  "input [name=text]": "handleTextChange",
  change: "handleAttributeChange",
};
